import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ArrowIcon } from '../../../Icons';

const FaqItem = ({ id, question, answer, isOpen, index, showMore, onToggle }) => {
  const optionClassNames = classNames(
    'faq-section__option',
    { 'faq-section__option-hidden': index > 4 && !showMore },
  );

  const arrowIconClassNames = classNames(
    'faq-section__option-button-icon',
    { 'faq-section__option-button-icon-arrow-up': isOpen },
  );

  const answerClassNames = classNames(
    'faq-section__option-answer',
    { 'faq-section__option-answer-open': isOpen },
  );

  return (
    <article
      className={optionClassNames}
    >
      <button
        className="faq-section__option-button"
        onClick={() => onToggle(id)}
        data-testid="faq-item-button"
      >
        <h4>{ question }</h4>

        <span
          className={arrowIconClassNames}
          data-testid="button-icon"
        >
          <ArrowIcon />
        </span>
      </button>
      <div
        className={answerClassNames}
      >
        { answer }
      </div>
    </article>
  );
};

FaqItem.propTypes = {
  id: PropTypes.string.isRequired,
  question: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.node.isRequired,
  ]).isRequired,
  answer: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.node.isRequired,
  ]).isRequired,
  isOpen: PropTypes.bool,
  index: PropTypes.number,
  showMore: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
};

FaqItem.defaultProps = {
  isOpen: false,
  index: 0,
  showMore: false,
};

export default FaqItem;
